import React from 'react'
import Contact from './style'
import SectionTitle from './Components/SectionTitle'
import { Col, Container, Row } from 'react-bootstrap'
import { useState, useEffect } from 'react'

import { Link } from 'gatsby'

import ThankYouPage from "./style1";
import Image from '~assets/image/mixed/1.png';


export default function ContactForm() {

  const url = 'https://getform.io/f/7560ba27-f028-4c6d-ba69-4dd11c8fd9f5'

  const [submited, setSubmited] = useState(false)


  const [email, setEmail] = useState('')

  const handleEmailChange = event => {
    setEmail(event.target.value)
  };

  const [number, setNumber] = useState('')

  const handleNumberChange = event => {
    setNumber(event.target.value)
  };

  const [message, setMessage] = useState('')

  const handleMessageChange = event => {
    setMessage(event.target.value)
  };


  const handleSubmit = event => {
    event.preventDefault();


    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, number, message })
    };
    fetch(url, requestOptions)
      .then(response => setSubmited(true))
      .catch(error => console.log('Form submit error', error))
  };





  // return (
  //   useEffect(() => {
  //     if (submited) {
  //       <ThankYou />
  //     } else {
  //       <Contact backgroundColor="#f3f4f6">
  //         <Container>
  //           <Row>
  //             <Col className="col-xl-7 col-lg-7">
  //               <Contact.Box >
  //                 <SectionTitle
  //                   subTitle="Contact Us"
  //                   title="Send A Message"
  //                   text="Please submit your information below. An axcer representative will contact you shortly after receiving your request."
  //                   subTitleProps={{ mb: "10px" }}
  //                   titleProps={{ mb: "10px", as: "h2" }}
  //                   mb="50px" />
  //               </Contact.Box>
  //               <Contact.From>
  //                 <form
  //                   onSubmit={handleSubmit}
  //                 // action="https://getform.io/f/7560ba27-f028-4c6d-ba69-4dd11c8fd9f5"


  //                 // name="contact-form"
  //                 // data-netlify="true"
  //                 // data-netlify-honeypot="bot-field"

  //                 >
  //                   <Row>
  //                     <Col xs="12" className="col-lg-6 mb-4">
  //                       <div className="form-floating">
  //                         <input className="form-control" placeholder="Leave a comment here" id="floatinginput" name="email" onChange={handleEmailChange} value={email} />
  //                         <label htmlFor="floatinginput">Your Email</label>
  //                       </div>
  //                     </Col>
  //                     <Col xs="12" className="col-lg-6 mb-4">
  //                       <div className="form-floating">
  //                         <input className="form-control" placeholder="Leave a comment here" id="floatinginput2" name="number" onChange={handleNumberChange} value={number} />
  //                         <label htmlFor="floatinginput2">Phone number</label>
  //                       </div>
  //                     </Col>
  //                     <Col xs="12" className="col-lg-12">
  //                       <div className="form-floating">
  //                         <textarea className="form-control" placeholder="Leave a comment here" id="floatingTextarea3" name="message" onChange={handleMessageChange} value={message} />
  //                         <label htmlFor="floatingTextarea3">Your Message Here </label>
  //                       </div>
  //                     </Col>
  //                     <Col xs="12" className="col-lg-12">
  //                       <Row className="align-items-center mt-3">
  //                         <div className="col-md-8 col-lg-7 col-md-6 col-xl-8 pt-3">
  //                           <div className="form-check d-flex align-items-center">
  //                             <input className="form-check-input bg-white float-none mt-0" type="checkbox" defaultValue id="flexCheckDefault" />
  //                             <label className="form-check-label" htmlFor="flexCheckDefault">
  //                               Your email address will not be published. Required fields are marked *
  //                             </label>
  //                           </div>
  //                         </div>
  //                         <Col xs="12" className="col-md-4 col-lg-5 col-xl-4 text-md-end pt-3">
  //                           <Contact.Button>Send Message</Contact.Button>
  //                         </Col>
  //                       </Row>
  //                     </Col>
  //                   </Row>
  //                 </form>
  //               </Contact.From>
  //             </Col>
  //             <Col xs="12" className="col-xl-5 col-lg-5">
  //               <Contact.WidgetsBox className="contact-widget-box">
  //                 <Contact.WidgetsBoxTitle as="h2">Get In Touch</Contact.WidgetsBoxTitle>
  //                 <Contact.WidgetsBoxText as="p"></Contact.WidgetsBoxText>
  //                 <Row>
  //                   <Col xs="12" className="col-lg-12 col-sm-6">
  //                     <Contact.Widgets>
  //                       <Contact.WidgetsIcon>
  //                         <i className="fas fa-envelope" />
  //                       </Contact.WidgetsIcon>
  //                       <Contact.WidgetsBoxBody>
  //                         <Contact.WidgetsTitle as="h3">visit us :</Contact.WidgetsTitle>
  //                         <Contact.WidgetsText as="p">Colombo, Sri Lanka
  //                           {/* <br className="d-block" /> NY 10002, USA */}
  //                         </Contact.WidgetsText>
  //                       </Contact.WidgetsBoxBody>
  //                     </Contact.Widgets>
  //                   </Col>
  //                   <Col xs="12" className="col-lg-12 col-sm-6 active">
  //                     <Contact.Widgets>
  //                       <Contact.WidgetsIcon>
  //                         <i className="fas fa-phone-alt" />
  //                       </Contact.WidgetsIcon>
  //                       <Contact.WidgetsBoxBody>
  //                         <Contact.WidgetsTitle as="h3">mail us :</Contact.WidgetsTitle>
  //                         <Contact.WidgetsText as="p">info@axcer.io
  //                           {/* <br className="d-block" /> contact@mail.com */}
  //                         </Contact.WidgetsText>
  //                       </Contact.WidgetsBoxBody>
  //                     </Contact.Widgets>
  //                   </Col>
  //                   <Col xs="12" className="col-lg-12 col-sm-6">
  //                     <Contact.Widgets>
  //                       <Contact.WidgetsIcon>
  //                         <i className="fas fa-map-marker-alt" />
  //                       </Contact.WidgetsIcon>
  //                       <Contact.WidgetsBoxBody>
  //                         <Contact.WidgetsTitle as="h3">call us :</Contact.WidgetsTitle>
  //                         <Contact.WidgetsText as="p">+94 7182 17615
  //                           {/* <br className="d-block" />+1 (123) 456 789 */}
  //                         </Contact.WidgetsText>
  //                       </Contact.WidgetsBoxBody>
  //                     </Contact.Widgets>
  //                   </Col>
  //                 </Row>
  //               </Contact.WidgetsBox>
  //             </Col>
  //           </Row>
  //         </Container>
  //       </Contact>
  //     }
  //   }, [submited])

  // )

  if (submited) {


    var buttonBack = document.getElementById('goback')


    return (

      <ThankYouPage backgroundColor="#f3f4f6">
        <Container>
          <Row className="justify-content-center">
            <Col xs="12" className="col-xl-6 col-lg-6 col-md-8 col-xs-10">

              <ThankYouPage.Image className="error-page__image text-center ">
                <img className="w-50 col-lg-3 col-xl-3 col-md-4 col-xs-5" src={Image} />
              </ThankYouPage.Image>

              <ThankYouPage.BigTitle as="h1">Thank You</ThankYouPage.BigTitle>
              <ThankYouPage.Title>The form was submited successfully</ThankYouPage.Title>
              {/* <ThankYouPage.Text>The page you are looking for is not available or<br className="d-none d-xs-block" /> doesn’t belong to this website!</ThankYouPage.Text> */}
              <ThankYouPage.ButtonGroup>
                <ThankYouPage.Button as={Link} className="btn-readical-red btn-1" to="/" onClick={() => setSubmited(false)} >Go back</ThankYouPage.Button>
                {/* <ThankYouPage.Button className="btn-outline-readical-red btn-2" to="#">Contact us</ThankYouPage.Button> */}
              </ThankYouPage.ButtonGroup>
            </Col>
          </Row>
        </Container>

      </ThankYouPage>

    )


  } else {
    return (

      <Contact backgroundColor="#f3f4f6">
        <Container>
          < Row >
            <Col className="col-xl-7 col-lg-7">
              <Contact.Box >
                <SectionTitle
                  subTitle="Contact Us"
                  title="Send A Message"
                  text="Please submit your information below. An axcer representative will contact you shortly after receiving your request."
                  subTitleProps={{ mb: "10px" }}
                  titleProps={{ mb: "10px", as: "h2" }}
                  mb="50px" />
              </Contact.Box>
              <Contact.From>
                <form
                  onSubmit={handleSubmit}
                // action="https://getform.io/f/7560ba27-f028-4c6d-ba69-4dd11c8fd9f5"


                // name="contact-form"
                // data-netlify="true"
                // data-netlify-honeypot="bot-field"

                >
                  <Row>
                    <Col xs="12" className="col-lg-6 mb-4">
                      <div className="form-floating">
                        <input className="form-control" placeholder="Leave a comment here" id="floatinginput" name="email" onChange={handleEmailChange} value={email} />
                        <label htmlFor="floatinginput">Your Email</label>
                      </div>
                    </Col>
                    <Col xs="12" className="col-lg-6 mb-4">
                      <div className="form-floating">
                        <input className="form-control" placeholder="Leave a comment here" id="floatinginput2" name="number" onChange={handleNumberChange} value={number} />
                        <label htmlFor="floatinginput2">Phone number</label>
                      </div>
                    </Col>
                    <Col xs="12" className="col-lg-12">
                      <div className="form-floating">
                        <textarea className="form-control" placeholder="Leave a comment here" id="floatingTextarea3" name="message" onChange={handleMessageChange} value={message} />
                        <label htmlFor="floatingTextarea3">Your Message Here </label>
                      </div>
                    </Col>
                    <Col xs="12" className="col-lg-12">
                      <Row className="align-items-center mt-3">
                        <div className="col-md-8 col-lg-7 col-md-6 col-xl-8 pt-3">
                          <div className="form-check d-flex align-items-center">
                            <input className="form-check-input bg-white float-none mt-0" type="checkbox" defaultValue id="flexCheckDefault" />
                            <label className="form-check-label" htmlFor="flexCheckDefault">
                              Your email address will not be published. Required fields are marked *
                            </label>
                          </div>
                        </div>
                        <Col xs="12" className="col-md-4 col-lg-5 col-xl-4 text-md-end pt-3">
                          <Contact.Button >Send Message</Contact.Button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </form>
              </Contact.From>
            </Col>
            <Col xs="12" className="col-xl-5 col-lg-5">
              <Contact.WidgetsBox className="contact-widget-box">
                <Contact.WidgetsBoxTitle as="h2">Get In Touch</Contact.WidgetsBoxTitle>
                <Contact.WidgetsBoxText as="p"></Contact.WidgetsBoxText>
                <Row>
                  <Col xs="12" className="col-lg-12 col-sm-6">
                    <Contact.Widgets>
                      <Contact.WidgetsIcon>
                        <i className="fas fa-envelope" />
                      </Contact.WidgetsIcon>
                      <Contact.WidgetsBoxBody>
                        <Contact.WidgetsTitle as="h3">visit us :</Contact.WidgetsTitle>
                        <Contact.WidgetsText as="p">Colombo, Sri Lanka
                          {/* <br className="d-block" /> NY 10002, USA */}
                        </Contact.WidgetsText>
                      </Contact.WidgetsBoxBody>
                    </Contact.Widgets>
                  </Col>
                  <Col xs="12" className="col-lg-12 col-sm-6 active">
                    <Contact.Widgets>
                      <Contact.WidgetsIcon>
                        <i className="fas fa-phone-alt" />
                      </Contact.WidgetsIcon>
                      <Contact.WidgetsBoxBody>
                        <Contact.WidgetsTitle as="h3">mail us :</Contact.WidgetsTitle>
                        <Contact.WidgetsText as="p">info@axcer.io
                          {/* <br className="d-block" /> contact@mail.com */}
                        </Contact.WidgetsText>
                      </Contact.WidgetsBoxBody>
                    </Contact.Widgets>
                  </Col>
                  <Col xs="12" className="col-lg-12 col-sm-6">
                    <Contact.Widgets>
                      <Contact.WidgetsIcon>
                        <i className="fas fa-map-marker-alt" />
                      </Contact.WidgetsIcon>
                      <Contact.WidgetsBoxBody>
                        <Contact.WidgetsTitle as="h3">call us :</Contact.WidgetsTitle>
                        <Contact.WidgetsText as="p">+94 7182 17615
                          {/* <br className="d-block" />+1 (123) 456 789 */}
                        </Contact.WidgetsText>
                      </Contact.WidgetsBoxBody>
                    </Contact.Widgets>
                  </Col>
                </Row>
              </Contact.WidgetsBox>
            </Col>
          </Row >
        </Container >
      </Contact >

    )
  }
}